var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGovernance({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "#FFC4DD"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_504_28)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.0118 10.5583C29.7031 10.2996 29.3411 10.1122 28.9516 10.0095C28.5621 9.90682 28.1548 9.8914 27.7587 9.96433L22.0937 10.9937C21.283 11.1399 20.5454 11.5552 20 12.1726C19.455 11.5542 18.7173 11.1379 17.9063 10.991L12.2413 9.96158C11.8451 9.88963 11.4379 9.90558 11.0486 10.0083C10.6592 10.111 10.2971 10.298 9.98796 10.556C9.67879 10.814 9.43006 11.1368 9.25934 11.5015C9.08863 11.8662 9.00009 12.264 8.99999 12.6667V28.0978L20 30.0989L31 28.0978V12.6667C31 12.2643 30.9115 11.8668 30.7408 11.5024C30.57 11.1381 30.3211 10.8157 30.0118 10.5583V10.5583ZM19.0833 28.0667L10.8333 26.5688V12.6667C10.8334 12.5325 10.863 12.3999 10.92 12.2784C10.9769 12.1569 11.0599 12.0493 11.163 11.9634C11.2661 11.8774 11.3868 11.8152 11.5165 11.781C11.6463 11.7468 11.782 11.7416 11.9141 11.7656L17.5782 12.795C18.0006 12.8719 18.3826 13.0945 18.6577 13.4242C18.9328 13.7539 19.0834 14.1696 19.0833 14.599V28.0667ZM29.1667 26.567L20.9167 28.0667V14.599C20.9166 14.1696 21.0672 13.7539 21.3423 13.4242C21.6174 13.0945 21.9994 12.8719 22.4218 12.795L28.0859 11.7656C28.218 11.7416 28.3537 11.7468 28.4834 11.781C28.6132 11.8152 28.7339 11.8774 28.837 11.9634C28.9401 12.0493 29.023 12.1569 29.08 12.2784C29.137 12.3999 29.1665 12.5325 29.1667 12.6667V26.567Z",
    fill: "#6F0D3C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_504_28"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white",
    transform: "translate(9 9)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGovernance);
export default __webpack_public_path__ + "static/media/governance.f1d96f2fa1009882bf73240c692e2a3a.svg";
export { ForwardRef as ReactComponent };